import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { LOGIN } from "../../store/actions/authenticationAction";
import { handleLoading } from "../../store/actions/loadingAction";
import validator from "validator";
const smalltalk = require("smalltalk");

function LoginScreen() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();

  const onChangePassword = (val) => {
    setPassword(val);
  };

  const onChangeLoginId = (val) => {
    setEmail(val);
  };

  const onSubmit = async () => {
    try {
      handleLoading();
      await checkValidation();
      await dispatch(LOGIN(email, password));
      handleLoading();
    } catch (e) {
      handleLoading();
      console.log(e)
      smalltalk.alert('',e == 1 ? "Email or password is invalid" : e);
    }
  };

  const checkValidation = async () => {
    if (!email || !password || !validator.isEmail(email)) {
      throw "Email or password invalid";
    }

    // let now = dayjs().format("HH");
    // if (now < 6 && now >= 1) {
    //   throw "This system is available for check-in from 6 am to 12 pm";
    // }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-darkCardIndexColor ">
      <img
        src={require('../../assets/h&h gym.png')}
        className="object-cover h-auto mb-10 w-[150px]"
      />
      <InputContainer
        onChangeLoginId={onChangeLoginId}
        email={email}
        password={password}
        onChangePassword={onChangePassword}
      />
      <SubmitButton onSubmit={onSubmit} />
    </div>
  );
}

const InputContainer = ({
  onChangeLoginId,
  onChangePassword,
  password,
  email,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <Input
        onChange={onChangeLoginId}
        value={email}
        placeholder='Email'
        type={0}
      />
      <Input
        onChange={onChangePassword}
        value={password}
        placeholder={'Password'}
        type={1}
      />
    </div>
  );
};

const Input = ({ placeholder, value, onChange, type }) => {
  const onChangeHandler = (val) => {
    let text = val.target.value;
    onChange(text);
  };

  return (
    <div className="w-2/5 p-2 bg-white border border-mainDark">
      <input
        value={value}
        onChange={onChangeHandler}
        type={type === 1 ? "password" : "text"}
        placeholder={placeholder}
        className="w-full h-full border-none outline-none"
      />
    </div>
  );
};

const SubmitButton = ({ onSubmit }) => {
  const { t } = useTranslation();

  return (
    <button
      className="flex items-center justify-center w-2/5 h-10 font-bold text-white cursor-pointer mt-11 bg-mainAqwaBlue"
      onClick={onSubmit}
    >
      Login
    </button>
  );
};

export default LoginScreen;
